// extracted by css-extract-rspack-plugin
export default {"wrap":"InventoryGlobe-module__wrap","stage":"InventoryGlobe-module__stage","ready":"InventoryGlobe-module__ready","sr":"InventoryGlobe-module__sr"};